<template>
	<div class="signup-player">
		<button
			v-if="isRemovable"
			class="button is-danger is-small is-outlined is-flex remove-player"
			@click="$emit('remove:player')">
				<b-icon icon="times-circle"></b-icon>
				<span>Remove Player</span>
		</button>
		<b-field :label="`${pluralLabel} Name`">
			<b-input
				required
				name="name"
				type="text"
				icon="user-circle"
				placeholder="Name"
				:value="player.name"
				@input="$emit('update:player', ['name', $event])"
			/>
		</b-field>
		<b-field :label="`${pluralLabel} Email`">
			<b-input
				required
				name="email"
				type="email"
				icon="envelope"
				placeholder="Email"
				:value="player.email"
				@input="$emit('update:player', ['email', $event])"
			/>
		</b-field>
		<b-field :label="`${pluralLabel} Phone Number${phoneRequired ? '' : ' (Optional)'}`">
			<b-input
				:required="phoneRequired"
				name="phone_number"
				type="tel"
				icon="mobile"
				placeholder="Phone Number"
				:value="player.phoneNumber"
				@input="$emit('update:player', ['phoneNumber', $event])"
			/>
		</b-field>
	</div>
</template>

<script>
	export default {
		name: "SignupPlayerDetail",
		props: {
			pluralLabel: {
				type: String,
				default: "Player's"
			},
			phoneRequired: {
				type: Boolean,
				default: false
			},
			player: {
				type: Object,
				required: true
			},
			isRemovable: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style scoped lang="scss">
	.signup-player {
		background-color: darken(white, 5%);
		padding: 0.5rem;
		margin-bottom: 0.5rem;
	}
	.remove-player {
		margin: auto 0 auto auto;
	}
</style>